// Utility compartido para agregar el pie de página institucional
// (logo Palma Plus + fecha + hora + número de página) a los PDFs
// generados en el frontend con jsPDF + autoTable.

let _palmaLogoDataURL = null;

/** Carga el logo Palma Plus como base64 (una sola vez, con cache). */
export async function loadPalmaLogo() {
  if (_palmaLogoDataURL) return _palmaLogoDataURL;
  try {
    const resp = await fetch("/brand/logo_palmaplus.png");
    const blob = await resp.blob();
    _palmaLogoDataURL = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    return _palmaLogoDataURL;
  } catch {
    return null;
  }
}

/** Devuelve `{fecha, hora}` en formato es-VE listo para imprimir. */
export function fechaHoraVE(date = new Date()) {
  return {
    fecha: date.toLocaleDateString("es-VE", { timeZone: "America/Caracas" }),
    hora: date.toLocaleTimeString("es-VE", { hour: "2-digit", minute: "2-digit", timeZone: "America/Caracas" }),
  };
}

/**
 * Dibuja el pie de página institucional en la página actual del PDF.
 * Uso: dentro del callback `didDrawPage` de autoTable.
 *
 * @param {jsPDF} doc
 * @param {object} opts
 * @param {string|null} opts.logoDataURL - Logo precargado con loadPalmaLogo()
 * @param {string} opts.fecha
 * @param {string} opts.hora
 * @param {number} opts.pageNumber
 */
export function drawPalmaFooter(doc, { logoDataURL, fecha, hora, pageNumber }) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const footerY = pageHeight - 30;

  if (logoDataURL) {
    try {
      // Alias "palma-logo" evita duplicar la imagen en cada página → PDFs livianos.
      doc.addImage(logoDataURL, "PNG", 40, footerY - 18, 28, 28, "palma-logo", "FAST");
    } catch (_) { /* ignore */ }
  }
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text(`${fecha} · ${hora}`, 76, footerY - 2);
  if (pageNumber != null) {
    doc.text(`Página ${pageNumber}`, pageWidth - 40, footerY - 2, { align: "right" });
  }
}
